module.exports = "<a href=\"#\" class=\"logo\">\n  <img src=\"assets/img/logo.png\" alt=\"\" width=\"147\" height=\"33\" class=\"logo-img\">\n</a>\n\n<span class=\"compress-logo\">\n  <img src=\"assets/img/logo-compress.png\" alt=\"\" width=\"38\" height=\"33\" class=\"logo-img\">\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/logo/logo.component.html
// module id = ../../../../../src/app/ui/logo/logo.component.html
// module chunks = 39